import { SerpElement } from "@nosto/search-js/preact/serp"
import { useNostoAppState } from "@nosto/search-js/preact/hooks"
import DynamicCard from "@/elements/DynamicCard/DynamicCard"
import type { Product } from "@/types"
import { isClearanceContext } from "@/mapping/clearanceContext"
import { getPreferredColor, getShopifyVariantId } from "@/utils/variantSelection"
import ProductCardSkeleton from "./ProductCardSkeleton"

export default function DynamicCardProduct({ product }: { product: Product }) {
  const searchQuery = useNostoAppState(state => state.query?.query)

  const isSkeleton = product.productId?.startsWith("skeleton-") || product.url === "#"

  if (isSkeleton) {
    return <ProductCardSkeleton />
  }

  if (!product.handle) {
    return null
  }

  const variantId = getShopifyVariantId(product)
  const preferredColor = getPreferredColor(searchQuery)
  const isClearance = isClearanceContext(searchQuery)
  const showOnlyClearanceSwatches = isClearance || undefined
  const orderRegularSwatchesFirst = !isClearance || undefined

  return (
    <SerpElement
      as={DynamicCard}
      hit={{
        productId: product.productId!,
        url: product.url
      }}
      componentProps={{
        handle: product.handle,
        template: "card",
        variantId,
        preferredColor,
        showOnlyClearanceSwatches,
        orderRegularSwatchesFirst
      }}
    />
  )
}
